export default __webpack_public_path__ + "static/media/grey_star.a28ddcfe.svg";